export const SET_DEFICIENCY_TYPES = 'setDeficiencyTypes'
